module.exports = __webpack_public_path__ + "static/media/cross-icon.6403e9d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cross-icon.svg
// module id = 627
// module chunks = 1 2 3 4 5 6 8 9 11 12 13